import { UploadStatus } from './upload-status.enum';
import { SingleFileUpload } from '../api/api';

export class FileUpload {
  public status: UploadStatus;
  public progress: number;
  public data: any;

  constructor(
    public file: File,
    public type: string,
    public parent?: any
  ) {
    this.status = 'NotStarted';
    this.progress = 0;

    const singleFileUpload: SingleFileUpload = new SingleFileUpload();
    singleFileUpload.file = file;
    this.data = singleFileUpload;
  }

  /*
  public updateProgress(progress: number) {
    this.progress = progress;
    this.status = UploadStatus.Started;
  }
  // TODO check progress role
   */

  public completed() {
    this.progress = 100;
    this.status = 'Done';
  }

  public uploaded() {
    this.progress = 100;
    this.status = 'Uploaded';
  }

  public failed() {
    this.progress = 0;
    this.status = 'Error';
  }

  get isWaitingForUpload() {
    return this.status === 'NotStarted';
  }
}
